<template>
  <page content-class="admin-campaign-list">
      <!-- Top-Level Settings Bar -->
      <b-card no-body class="campaign-settings-menu bg-light px-4 pt-3 pb-2 mt-3">
        <div class="d-flex justify-content-between pb-1">
          <h3><strong>Settings</strong></h3>
          <div class="d-flex justify-content-end align-items-center">
            <span
              class="mr-4"
              style="width: 120px"
              @click="$router.push({ name: 'EmailSetup' })"
            >
              Connect Email
            </span>
            <span
              class="text-primary font-weight-bold"
              style="width: 150px"
            >
              Edit Email Signature
            </span>
          </div>
        </div>
      </b-card>
      <!-- Main Content Card -->
      <b-card body-class="p-4" class="mt-3">
        <b-row class="justify-content-center">
          <b-col cols="12" sm="12" xs="12">
            <h3>Edit Email Signature</h3>
            <p class="text-dark">Add your email signature here</p>
            <!-- Signature Field -->
              <b-form-textarea
                id="signature"
                v-model="signatureField"
                :placeholder="`(e.g.) Mary Doe${'\n'}Lead Recruiter at Company XYZ`"
                rows="5"
                max-rows="6"
              />
          </b-col>
        </b-row>
        <div class="d-flex mt-3">
          <div class="flex-fill"/>
          <!-- Save Button -->
          <b-btn
            class="text-right"
            variant="primary"
            @click="updateSignature()"
          >
            Save Signature
          </b-btn>
        </div>
      </b-card>
    </page>
</template>

<script>
import Page from '@/components/campaign-admin/page';
import CurrentUserEditMutation from '@/graphql/mutations/CurrentUserEdit.gql';
import { mapRoot } from '@src/mixins/root';

export default {
  components: {
    Page
  },
  data: () => ({
    signatureField: null
  }),
  computed: {
    ...mapRoot([ 'user' ]),
  },
  mounted() {
    if (this.user && this.user.state && this.user.state.emailSignature) {
      this.signatureField = this.user.state.emailSignature;
    }
  },
  methods: {
    async updateSignature() {
      const { signatureField: emailSignature } = this;
      const { id: userID } = this.user;
      if (!emailSignature && emailSignature.length < 3) return;
      try {
        const update = { state: { emailSignature } };
        this.$log.debug({ update });

        await this.$apollo.mutate({
          mutation: CurrentUserEditMutation,
          variables: { userID, update },
        });

        this.$notification({ message: 'Email signature has been saved successfully', variant: 'success' });
      } catch (error) {
        this.$notifyErr(error, { prepend: 'Failed to save email signature.' });
        console.log(error);
      }
    }
  },
};
</script>

<style lang="scss">
  .referral-jam-event-settings {
      .event-logo {
          max-height: 30px;
          max-width: 200px;
      }
  }
  .campaign-settings-menu {
    div > span:hover {
      cursor: pointer;
      font-weight: 600;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/campaign-admin/EmailSignature.vue